import { render, staticRenderFns } from "./editAdGroup.vue?vue&type=template&id=8ccd2f1c"
import script from "./editAdGroup.vue?vue&type=script&lang=js"
export * from "./editAdGroup.vue?vue&type=script&lang=js"
import style0 from "./editAdGroup.vue?vue&type=style&index=0&id=8ccd2f1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports